/* eslint-disable no-console */
import { create, StoreApi, UseBoundStore } from 'zustand';
import getErrorMessage from '../utils/error';
import { IContactPerson, IResponse } from '../types/types';
import { getAllContact } from '../utils/api';

interface IUseContact {
  loading: boolean;
  contact: IContactPerson | null;
  contacts: IContactPerson[] | null;
  fetchContact: () => Promise<IResponse>;
}

const useContact: UseBoundStore<StoreApi<IUseContact>> = create((set) => ({
  loading: false,
  contact: null,
  contacts: null,
  fetchContact: async () => {
    try {
      set(() => ({ loading: true }));
      const { success, message, data } = await getAllContact();

      if (!success) {
        throw new Error(message);
      }

      set(() => ({ contacts: data }));

      return {
        success: true,
        message,
      };
    } catch (error: unknown) {
      const errorMessage = getErrorMessage(error);
      console.error(errorMessage);
      return {
        success: false,
        message: errorMessage,
      };
    } finally {
      set(() => ({ loading: false }));
    }
  },
}));

// Subscribe untuk mengecek perubahan state
// eslint-disable-next-line @typescript-eslint/no-unused-vars
// const unsubscribe = useContact.subscribe((state) => {
//   console.log('State contact:', state);
// });

export default useContact;
